import {Url} from '@/utils/url';

const DownloadEtaReportApi = {
  getFileDownloadUrl() {
    return Url.withContextPath(`/my-account/backorder/etachanges/export/`);
  },
};

export {DownloadEtaReportApi};
